/**
 * Types that can be converted to an array by to_array.
 *
 * Includes primitives, null/undefined, arrays, records, and iterables.
 */
export type IterableLike<T = unknown> =
  | T
  | null
  | undefined
  | T[]
  | Record<string, T>
  | Iterable<T>
